<template>
  <div>
    <Card>
      <Table
          :loading="dataLoading"
          :columns="columns"
          :data="data"
          :border="false"
          :stripe="false"
          :highlight-current-row="true"
      >
      </Table>
      <Page style="text-align: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="dataTotal"
            :page-size="pageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="currentPage"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>

<script>
export default {
  name: "deviceList",
  data() {
    return {
      regionId: '',
      dataLoading: false,
      dataTotal: 0,
      columns: [
        {
          title: '设备名',
          align: 'center',
          // width: '250',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.deviceName)
          }
        },
        {
          title: '设备码',
          align: 'center',
          // width: '200',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.deviceCode)
          }
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1
    }
  },
  mounted() {
    this.getDeviceList()
  },
  methods: {
    getDeviceList() {
      this.dataLoading = true
      this.accessToken = localStorage.getItem('tyToken')
      this.regionId = this.$route.query.regionId
      this.$http.get(`/api/tysl/getDeviceList?accessToken=${this.accessToken}&regionId=${this.regionId}&pageNo=${this.currentPage}&&pageSize=${this.pageSize}`).then(res => {
        console.log(res)
        if (res.data.status === '200') {
          this.data = res.data.data.list
          this.dataTotal = res.data.data.totalCount
          this.dataLoading = false
        }
      })
    },
    pageChange(page) {
      this.currentPage = page
      this.getDeviceList()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getDeviceList()
    }
  }
}
</script>

<style scoped>

</style>
